export interface ErrorModel {
  message: string;
  stack: string;
}

export const initialErrorModel: ErrorModel = {
  message: '',
  stack: ''
};
